<template>
  <div>
    <pageHeader :headerIcon="'circle user'"
                :headerText="$t('employees')"
                :haveFilterInput="false">
    </pageHeader>

    <div class="ui grid" style="padding-top: 20px;">
      <div class="four wide column">
        <div class="ui vertical secondary pointing menu" style="width: 100%">
          <a class="item"
             :class="{ active: currentTab === tabs.first }"
             @click="currentTab = tabs.first">
            {{ $t('current') }}
          </a>

          <a class="item" :class="{ active: currentTab === tabs.second }"
             @click="currentTab = tabs.second">
            {{ $t('archived') }}
          </a>

          <a class="item" :class="{ active: currentTab === tabs.third }"
             @click="currentTab = tabs.third">
            {{ $t('all') }}
          </a>
        </div>
      </div>
      <div class="twelve wide column">
        <div v-if="loading" class="ui active centered inline loader">
          <div class="ui text loader">{{ $t('loading') }}...</div>
        </div>

        <div class="ui two columns stackable grid" v-if="!loading && getEmployees().length">
          <div class="column" v-for="employee in getEmployees()" v-if="getEmployees().length">
            <div class="ui raised link fluid stackable card"
                 @click="navigateTo('Show_Employee', { key: 'params', value: { id: employee.id } })">
              <div class="content">
                <img class="right floated mini ui image image-size"
                     src="~@/assets/image.png"
                     v-if="employee.album.images.length < 1">
                <img class="right floated mini ui image image-size"
                     :src="getImage(employee.album)"
                     v-else>

                <div class="header" style="display:flex; align-items:center">
                  <div id="circle" :class="{ 'red-cirle': employee.deleted_at }"></div>
                  {{ employee.user.name }}
                </div>

                <div class="description">
                  <strong> {{ $t('email') }}: </strong> {{ employee.user.email }}
                </div>
                <div class="description">
                  <strong> {{ $t('mobile') }}: </strong> {{ employee.user.mobile }}
                </div>
                <div class="description">
                  <strong> {{ $t('salary') }}: </strong> {{ employee.salary_amount }}
                </div>
                <div class="description">
                  <strong>{{ $t('hireDate') }}:</strong> {{ employee.hire_date | moment('DD/MM/YYYY') }}
                </div>
              </div>
            </div>
            <!-- <div class="ui raised link fluid stackable card"
                 @click="navigateTo('Show_Employee', { key: 'params', value: { id: employee.id } })">
              <div class="content">
              </div>
              <div class="image" style="min-height: 150px;">
              </div>
              <div class="content">
              </div>
            </div> -->
          </div>
        </div>

        <div class="ui placeholder segment" style="margin-bottom: 50px"
             v-if="!loading && !getEmployees().length">
          <div class="ui icon header" style="color: #092442">
            <i class="dont icon"></i>
            {{ $t('thereIsNoArchivedEmployeeYet') }}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  components: {
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      loading: true,
      employees: [],
      tabs: {
        first: 'current',
        second: 'archived',
        third: 'all'
      },
      currentTab: 'current'
    }
  },
  mounted () {
    this.$http.get('employees', {
      params: {
        clinic_id: this.getFromLocalStorage('clinicId')
      }
    }).then(response => {
      this.employees = response.data
      this.loading = false
    })
  },
  computed: {
  },
  methods: {
    getImage (album) {
      return album.images[album.images.length - 1].picture.url
    },
    getEmployees () {
      if (this.currentTab === this.tabs.first) {
        return window._.filter(this.employees, employee => {
          return !employee.deleted_at
        })
      } else if (this.currentTab === this.tabs.second) {
        return window._.filter(this.employees, employee => {
          return employee.deleted_at
        })
      } else if (this.currentTab === this.tabs.third) {
        return this.employees
      }
    }
  }
}
</script>
<style scoped>
  .padding-header {
    padding-bottom: 20px;
  }

  .red-cirle {
    background-color: red !important;
  }

  .image-size {
    height: 30px !important;
    object-fit: contain;
  }
</style>



// WEBPACK FOOTER //
// src/components/employees/Employees.vue